import { getSingleChoices } from "@dashboard/components/Attributes/utils";
import { Combobox } from "@dashboard/components/Combobox";
import { DEFAULT_INITIAL_SEARCH_DATA } from "@dashboard/config";
import { AttributeFragment, AttributeValueFragment } from "@dashboard/graphql";
import useAttributeValueSearchHandler from "@dashboard/utils/handlers/attributeValueSearchHandler";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React from "react";

interface ProductTypeVariantAttributeModifierDefaultValueSelectProps {
  attribute: AttributeFragment;
  setModifierDefaultAttributeValue: (attributeValueId: AttributeValueFragment | null) => void;
  modifierDefaultAttributeValue: AttributeValueFragment | null;
}

const ProductTypeVariantAttributeModifierDefaultValueSelect: React.FC<
  ProductTypeVariantAttributeModifierDefaultValueSelectProps
> = props => {
  const { attribute, setModifierDefaultAttributeValue, modifierDefaultAttributeValue } = props;

  const {
    loadMore: loadMoreAttributeValues,
    search: searchAttributeValues,
    result: searchAttributeValuesOpts,
    reset: searchAttributeReset,
  } = useAttributeValueSearchHandler(DEFAULT_INITIAL_SEARCH_DATA);

  const fetchMoreAttributeValues = {
    hasMore: !!searchAttributeValuesOpts.data?.attribute?.choices?.pageInfo?.hasNextPage,
    loading: !!searchAttributeValuesOpts.loading,
    onFetchMore: loadMoreAttributeValues,
  };

  const attributeValues =
    mapEdgesToItems(searchAttributeValuesOpts?.data?.attribute?.choices) || [];

  return (
    <Combobox
      alwaysFetchOnFocus
      options={getSingleChoices(attributeValues)}
      value={
        modifierDefaultAttributeValue
          ? {
              value: modifierDefaultAttributeValue.slug!,
              label: modifierDefaultAttributeValue.name!,
            }
          : null
      }
      name={`attribute:${attribute.name}`}
      id={`attribute:${attribute.name}`}
      label=""
      fetchOptions={query => {
        searchAttributeValues(query, attribute.id);
      }}
      onChange={e => {
        const attributeValue = attributeValues.find(v => v.slug === e.target.value);

        setModifierDefaultAttributeValue(attributeValue ?? null);
      }}
      loading={searchAttributeValuesOpts.loading}
      onBlur={searchAttributeReset}
      fetchMore={fetchMoreAttributeValues}
    />
  );
};

ProductTypeVariantAttributeModifierDefaultValueSelect.displayName =
  "ProductTypeVariantAttributeModifierDefaultValueSelect";
export default ProductTypeVariantAttributeModifierDefaultValueSelect;
